// Custom JS Application Code
function validate_email_js(email) { var reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/; if(reg.test(email) == false) { return false; } return true; }
var ellipsisText = function (e, etc) { var wordArray = e.innerHTML.split(" "); while (e.scrollHeight > e.offsetHeight) { wordArray.pop(); e.innerHTML = wordArray.join(" ") + (etc || "..."); } };

var cf7Success = function (event) {
	if (newsletterFormID == event.detail.contactFormId ) {
		var message = $('#newsletterSuccessMessage');
		smoother.paused(true);
		message.fadeIn();
	}else{
		var message = $('#contactsSuccessMessage');
		smoother.paused(true);
		message.fadeIn();
	}
};
var cf7Error = function (event) {
	if (newsletterFormID == event.detail.contactFormId ) {
		var message = $('#newsletterErrorMessage');
		smoother.paused(true);
		message.fadeIn();
	}else{
		var message = $('#contactsErrorMessage');
		smoother.paused(true);
		message.fadeIn();
	}
};
var cf7Invalid = function (event) {
	if (newsletterFormID == event.detail.contactFormId ) {
		var message = $('#newsletterErrorMessage');
		var invalidFields = event.detail.apiResponse.invalid_fields;
		for (let i = 0; i < invalidFields.length; i++) {
			var invalidField = invalidFields[i].field;
			var messageInfo = invalidFields[i].message;
			if (invalidField=='your-email' && messageInfo=='email-already-subscribed') {
				message = $('#newsletterError2Message');
			}
		}
		smoother.paused(true);
		message.fadeIn();
	}else{
		var message = $('#contactsErrorMessage');
		smoother.paused(true);
		message.fadeIn();
	}
};

function checkHeaderOffset() {
	var $window = $(window);
	var offset = $window.scrollTop();
	if (offset>=30) {
		$('#headerWrapper').addClass('scrolled');
	}else{
		$('#headerWrapper').removeClass('scrolled');
	}
}

function windowOnResize() {
	var myWidth, myHeight;
	if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
	else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
	else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
	browserWidth = myWidth;
	browserHeight = myHeight;
}
function pageScroll() {
	//console.log('scrolled');
	checkHeaderOffset();
}

function checkEntryYoutubeVideos() {
	var iframes = document.getElementsByTagName('iframe');
	var key = /youtube.com/;
	for (var i = 0; i != iframes.length; ++i) {
		var match = iframes[i].src.search(key);
		if(match != -1) {
			$(iframes[i]).eq(0).addClass('video-player');
			$(iframes[i]).eq(0).closest('.with-iframe').addClass('video-wrapper');
		}
	}
}
function checkEntryVimeoVideos() {
	var iframes = document.getElementsByTagName('iframe');
	var key = /vimeo.com/;
	for (var i = 0; i != iframes.length; ++i) {
		var match = iframes[i].src.search(key);
		if(match != -1) {
			$(iframes[i]).eq(0).addClass('video-player');
			$(iframes[i]).eq(0).closest('.with-iframe').addClass('video-wrapper');
		}
	}
}

function initNav(t) {
	var inTop = t.delta.y==0;
	var $window = $(window);
	if (inTop) {
		$('#headerWrapper').removeClass('scrolled');
		$('#headerWrapper').removeClass('scrolled-2');
		$('#headerWrapper').removeClass('scrolled-up');
	}else{
		if (t.direction=='up') {
			$('#headerWrapper').removeClass('scrolled');
			//$('#headerWrapper').addClass('scrolled-up scrolled-2');
		}else if (t.direction=='down') {
			$('#headerWrapper').addClass('scrolled');
			//$('#headerWrapper').removeClass('scrolled-up');
		}
	}
	return;
}

function scrollToSlide(slideTo) {
	$('body,html').animate({ scrollTop: $('.'+slideTo).offset().top-$('header').height() }, 800);
}

function projectsListScrollAnimationKill() {
	gsap.set('.project-item .aux .image', {
		opacity: 1,
		y: 0,
		scale: 1,
	});
	gsap.set('.project-item .aux .info', {
		opacity: 1,
		y: 0,
		scale: 1,
	});
}

function projectsListFilter() {
	projectsListScrollAnimationKill();
	$('ul.filters-list li a').css('pointer-events','none');

	var filteredJSON = JSON.parse('[]');

	var allProjects = $('.project-item');

	var categorySelected = $('ul.filters-list li.active a');

	var categoryId = (categorySelected.length ? parseInt(categorySelected.data('category'),10) : 0);

	var isFiltered = categoryId!=0;

	if (isFiltered) { $('.projects-list').addClass('is-filtered'); }

	allProjects.each(function() {
		var objIsValid = true;
		var itemCategory = parseInt($(this).data('category'),10);
		var itemId = parseInt($(this).data('id'),10);

		if (categoryId!=0) {
			if (categoryId!=itemCategory) {
				objIsValid = false;
			}
		}
		if (objIsValid) { filteredJSON.push(itemId); }
		/*
		if (objIsValid) {
			$(this).css('style','inline-block');
			$(this).addClass('is-visible');
		}else{
			$(this).css('style','none');
			$(this).removeClass('is-visible');
		}*/
	});

	var items = gsap.utils.toArray('.project-item');

	const state = Flip.getState(items);

	var countItems = 0;
	items.forEach(function(item) {
		var itemID = parseInt(item.dataset.id,10);
		var itemElem = $(item).eq(0);
		if (!filteredJSON.includes(itemID)) {
			item.style.display = "none";
			itemElem.removeClass('is-visible');
		}else{
			item.style.display = "inline-block";
			itemElem.addClass('is-visible');
			countItems++;
		}
	});

	Flip.from(state, {
		duration: 0.25,
		scale: true,
		ease: "power1.inOut",
		stagger: 0,
		absolute: true,
		onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1, duration: 0.25}),
		onLeave: elements => gsap.to(elements, {opacity: 0, duration: 0.25}),
		onComplete: toggleFilteredList,
		onCompleteParams: [isFiltered],
	});
}

function toggleFilteredList(isFiltered) {
	if (!isFiltered) { $('.projects-list').removeClass('is-filtered'); }
	$('ul.filters-list li a').css('pointer-events','');
	ScrollTrigger.refresh();
}

(function($) {
	"use strict"; // Start of use strict
	$(window).bind('hashchange');
	$(window).trigger('hashchange');
	$(window).scroll( function() { /*disableScroll();*/ pageScroll(); } );
	$(window).resize(function() { windowOnResize(); });
	$(window).ready(function() {
		var myWidth, myHeight;
		if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
		browserWidth = myWidth;
		browserHeight = myHeight;

		//if ($(window).width()>=1024) { new WOW().init(); }

		//$('.go-top a').click(function () { $('body,html').animate({ scrollTop: 0 }, 800); $(this).blur(); return false; });

		$('.button-arrow').each(function() {
			$(this).html('<span class="icon"><svg class="hover"><use xlink:href="#arrow-right-btn"></use></svg><svg class="normal"><use xlink:href="#arrow-right-btn"></use></svg></span>');
		});

		$('.entry-wysiwyg p iframe').closest('p').addClass('with-iframe');
		$('.entry-wysiwyg figure iframe').closest('figure').addClass('with-iframe');

		checkEntryYoutubeVideos();
		checkEntryVimeoVideos();

		$('.entry-wysiwyg p > img,.entry-wysiwyg p > video').closest('p').addClass('image-wrapper');
		$('.entry-wysiwyg p > img,.entry-wysiwyg p > video').addClass('responsive-full');

		$('.entry-wysiwyg figure > img:not(.alignleft,.alignright,.aligncenter),.entry-wysiwyg figure > a > img:not(.alignleft,.alignright,.aligncenter)').closest('figure').addClass('image-wrapper');
		$('.entry-wysiwyg figure > img:not(.alignleft,.alignright,.aligncenter),.entry-wysiwyg figure > a > img:not(.alignleft,.alignright,.aligncenter)').addClass('responsive-full');
		$('.entry-wysiwyg figure > video,.entry-wysiwyg figure > a > video').closest('figure').addClass('image-wrapper');
		$('.entry-wysiwyg figure > video,.entry-wysiwyg figure > a > video').addClass('responsive-full');


		$('.nav-toggle').bind('click',function(ev) {
			if ($('.nav-wrapper').hasClass('opened')) {
				$('.nav-wrapper').fadeOut(0,function() {
					$(this).removeClass('opened');
					$('#headerWrapper').removeClass('opened');
				});
				$(this).removeClass('is-active');
			}else{
				$('#headerWrapper').addClass('opened');
				$('.nav-wrapper').fadeIn(0,function() {
					$(this).addClass('opened');
				});
				$(this).addClass('is-active');
			}

			$(this).blur();
			ev.preventDefault();
		});

		$('.js-toggle-service').bind('click',function(ev) {
			var item = $(this).closest('.service-item');
			var servicesList = item.closest('.services-list');
			var currentItem = servicesList.find('.service-item.opened');
			if (item.hasClass('opened')) {
				item.toggleClass('opened');
				item.find('.description').slideToggle();
			}else{
				if (currentItem.length) {
					currentItem.toggleClass('opened');
					currentItem.find('.description').slideToggle();
				}
				item.toggleClass('opened');
				item.find('.description').slideToggle();
			}
			$(this).blur(); ev.preventDefault();
		});
		/*

		$('.js-toggle-service').bind('click',function(ev) {
			var item = $(this).closest('.service-item');
			item.toggleClass('opened');
			console.log(item.find('.description'));
			//item.find('.description').toggle();
			$(this).blur(); ev.preventDefault();
		});
		*/

		$('.js-popup-gallery-close').bind('click',function(ev) {
			smoother.paused(false);
			$('.project-gallery .swiper-custom-button-prev').show();
			$('.project-gallery .swiper-custom-button-next').show();
			$('.popup-gallery-wrapper').removeClass('--active');
			gsap.to('.popup-gallery-wrapper', { top: '-110vh', duration: 0.5 });
			//setTimeout(function(){$('.popup-gallery-wrapper').removeClass('show');}, 1500);
			$(this).blur(); ev.preventDefault();
		});

		$('.js-show-media-popup').bind('click',function(ev) {
			var mediaItem = $(this).closest('.media-item');
			var galleryID = mediaItem.data('id');
			smoother.paused(true);
			$('#popupGallery'+galleryID).addClass('--active');
			gsap.to('#popupGallery'+galleryID, { top: 0, duration: 0.75 });
			$(this).blur(); ev.preventDefault();
		});

		$('.js-show-project-popup').bind('click',function(ev) {
			smoother.paused(true);
			$('.popup-gallery-wrapper').addClass('--active');
			$('.project-gallery .swiper-custom-button-prev').hide();
			$('.project-gallery .swiper-custom-button-next').hide();
			gsap.to('.popup-gallery-wrapper', { top: 0, duration: 0.75 });
			$(this).blur(); ev.preventDefault();
		});

		$('.js-toggle-contacts').bind('click',function(ev) {
			var dataID = $(this).data('id');
			$('.contacts-tab').removeClass('active');
			$('#contactsTab'+dataID).addClass('active');

			$('.contacts-info .contacts-nav li').removeClass('active');
			$(this).parent().addClass('active');
			$(this).blur(); ev.preventDefault();
		});

		$('.js-filter-projects-list').bind('click',function(ev) {
			var filtersList = $(this).closest('.filters-list');
			var filterItem = $(this).closest('li');
			filtersList.find('li').removeClass('active');
			filterItem.addClass('active');
			projectsListFilter();
			$(this).blur(); ev.preventDefault();
		});

		$('.js-toggle-projects-slider').bind('click',function(ev) {
			var categoryID = $(this).data('category');
			var filtersList = $(this).closest('.filters-list');
			var filterItem = $(this).closest('li');
			filtersList.find('li').removeClass('active');
			filterItem.addClass('active');
			$('.projects-slider').removeClass('active');
			$('.projects-slider').hide();
			$('#projectsSlider'+categoryID).show();
			$('#projectsSlider'+categoryID).addClass('active');

			$(this).blur(); ev.preventDefault();
		});

		$('.js-accept-cookies').bind('click',function(ev) {
			$('.cookies-popup-wrapper').fadeOut();
			Cookies.set('cookies_accepted', '1', { expires: 90 });
			$(this).blur(); ev.preventDefault();
		});
		if (Cookies.get('cookies_accepted')==undefined) { $('.cookies-popup-wrapper').show(); }


		/* FORMS */
		$('.js-close-message-popup').bind('click',function(ev) {
			$('.message-popup-wrapper').fadeOut();
			smoother.paused(false);
			$(this).blur(); ev.preventDefault();
		});
		$('.js-form-submit').bind('click',function(ev) {
			$(this).closest('form.wpcf7-form').find('.wpcf7-submit').click();
			$(this).blur(); ev.preventDefault();
		});
		$('.js-newsletter-submit').bind('click',function(ev) {
			$(this).closest('form.wpcf7-form').find('.wpcf7-submit').click();
			$(this).blur(); ev.preventDefault();
		});

		document.addEventListener('wpcf7mailsent', cf7Success, false);
		document.addEventListener('wpcf7invalid', cf7Invalid, false);
		document.addEventListener('wpcf7spam', cf7Error, false);
		document.addEventListener('wpcf7mailfailed', cf7Error, false);

		// Close popup gallery if esc key is pressed
		document.body.addEventListener('keydown', function(e) {
			if (e.key == "Escape" && $('.popup-gallery-wrapper.--active')) {
				smoother.paused(false);
				$('.project-gallery .swiper-custom-button-prev').show();
				$('.project-gallery .swiper-custom-button-next').show();
				gsap.to('.popup-gallery-wrapper', { top: '-110vh', duration: 0.5 });
			}
		});

	});
	$(window).on('load',function() {
		var myWidth, myHeight;
		if( typeof( window.innerWidth ) == 'number' ) { myWidth = window.innerWidth; myHeight = window.innerHeight; }
		else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { myWidth = document.documentElement.clientWidth; myHeight = document.documentElement.clientHeight; }
		else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { myWidth = document.body.clientWidth; myHeight = document.body.clientHeight; }
		browserWidth = myWidth;
		browserHeight = myHeight;

		if ($('.popup-gallery-wrapper').length) {
			$('.popup-gallery-wrapper').each(function() {
				var id = $(this).attr('id');
				new Swiper('#'+id+' .swiper-container', {
					slidesPerView: 1,
					centeredSlides : false,
					spaceBetween: 0,
					loop: true,
					autoHeight: false,
					pagination: {
						el: '#'+id+' .swiper-custom-pagination',
						type: 'fraction',
					},
					navigation: {
						nextEl: '#'+id+' .swiper-custom-button-next',
						prevEl: '#'+id+' .swiper-custom-button-prev',
					},
				});
			});
		}

		if ($('.project-gallery').length) {
			$('.project-gallery').each(function() {
				var id = $(this).attr('id');
				new Swiper('.project-gallery .swiper-container', {
					slidesPerView: 1,
					centeredSlides : false,
					spaceBetween: 0,
					loop: true,
					autoHeight: false,
					pagination: {
						el: '#'+id+' .swiper-custom-pagination',
						type: 'custom',
						renderCustom: function(swiper,current,total) {
							return '<span class="current">' + (current<10 ? '0' : '') + current + '</span> <span>/</span> <span>' + (total<10 ? '0' : '') + total + '</span>';
						}
					},
					navigation: {
						nextEl: '#'+id+' .swiper-custom-button-next',
						prevEl: '#'+id+' .swiper-custom-button-prev',
					},
				});
			});
		}

		if ($('.hp-featured-projects').length) {

			/**
			 * Spring Slider element
			 */
			const sliderEl = document.querySelector('.featured-projects-slider');

			/**
			 * Init Spring Slider
			 *
			 * argument: pass .spring-slider element and swiper params
			 */
			featuredProjectsSlider = createSpringSlider(sliderEl, {
				loop: true,
				slidesPerView: 'auto',
				navigation: {
					nextEl: '.hp-featured-projects .swiper-custom-button-next',
					prevEl: '.hp-featured-projects .swiper-custom-button-prev',
				},
				on: {
					slideChangeTransitionEnd: function (ev) {
						console.log(this);
						var currentBlock = $(this.el).closest('.hp-featured-projects');
						var infoList = currentBlock.find('.featured-info-list .featured-info');
						var currentSlide = $('.swiper-slide.swiper-slide-active .image-item');
						var realIndex = currentSlide.data('item');
						infoList.removeClass('active');
						infoList.eq(realIndex-1).addClass('active');
					},
				},
			});

			/*
			featuredProjectsSlider = new Swiper('.hp-featured-projects .swiper-container', {
				slidesPerView: 'auto',
				centeredSlides : false,
				loop: true,
				//loopedSlides: 3,
				autoHeight: false,
				spaceBetween: 12,
				navigation: {
					nextEl: '.hp-featured-projects .swiper-custom-button-next',
					prevEl: '.hp-featured-projects .swiper-custom-button-prev',
				},
				on: {
					slideChangeTransitionEnd: function (ev) {
						console.log(this);
						var currentBlock = $(this.el).closest('.hp-featured-projects');
						var infoList = currentBlock.find('.featured-info-list .featured-info');
						var currentSlide = $('.swiper-slide.swiper-slide-active .image-item');
						var realIndex = currentSlide.data('item');
						infoList.removeClass('active');
						infoList.eq(realIndex-1).addClass('active');
					},
				},
			});
			*/
		}

		if ($('.projects-slider').length) {
			$('.projects-slider').each(function() {
				var id = $(this).attr('id');
				new Swiper('#'+id+'.swiper-container', {
					slidesPerView: 'auto',
					centeredSlides : false,
					spaceBetween: 0,
					loop: false,
					autoHeight: false,
					freeMode: true,
					spaceBetween: 12
				});
			});
			$('.projects-slider').hide();
			$('#projectsSlider1').show();
		}
	});

})(jQuery); // End of use strict

window.addEventListener('DOMContentLoaded', (event) => {
	gsap.registerPlugin(ScrollTrigger,SplitText,Flip,ScrollSmoother);

	//ScrollTrigger.normalizeScroll(true);

	smoother = ScrollSmoother.create({
		smooth: 3,
		effects: true,
		//onUpdate: self => console.log("direction:", self.direction)
	});

	smoother.effects(".img-parallax img", { speed: "auto" });

});
window.addEventListener('DOMContentLoaded', (event) => {
	(function($) {
		"use strict"; // Start of use strict
		$(window).on('load',function() {
			ScrollTrigger.matchMedia({
				"(max-width: 767px)": function() {},
				"(min-width: 800px)": function() {},
				"(min-width: 834px)": function() {},
				"(min-width: 1024px)": function() {},
				"all": function() {
					var newScrollDirection = 'down';
					const body = document.querySelector('body');
					const headerWrapper = document.getElementById('headerWrapper');
					ScrollTrigger.create({
						//markers: true,
						trigger: body,
						start: 'top 20%',
						onUpdate: self => {
						  if (self.direction === 1) {
							newScrollDirection = 'down';
							headerWrapper.classList.add('scrolled-down');
							headerWrapper.classList.remove('scrolled-up');
						  } else {
							newScrollDirection = 'up';
							headerWrapper.classList.add('scrolled-up');
							headerWrapper.classList.remove('scrolled-down');
						  }
						  if (lastScrollDirection!=newScrollDirection) {
							lastScrollDirection = newScrollDirection;
							if ($('.images-wrapper-scroll').length) {
								imagesLoop.timeScale(imagesLoop.timeScale() * -1);
							}
						  }
						},
						onLeaveBack: () => {
						  headerWrapper.classList.remove('scrolled-up');
						},
					});

					if ($('.projects-list-page-wrapper').length) {
						$('.projects-list').css('min-height',$('.project-item').eq(0).height()+'px');
						gsap.set('.image', {
							//opacity: 0,
							y: 25,
							//scale: 0.8,
						});
						gsap.set('.info', {
							//opacity: 0,
							y: 25,
							//scale: 1,
						});
						ScrollTrigger.batch('.project-item .aux', {
							onEnter: batch => {
								batch.forEach((card, index) => gsap.to(card.children, {opacity: 1, y: 0, scale: 1, stagger: 0.2, delay: index * 0.3}))
							},
							once: true
						});
					}


					if ($('.projects-slider').length) {
						$('.projects-slider').each(function() {
							var id = $(this).attr('id');
							var projectsSliderTimeline = gsap.timeline().paused(true);
							gsap.set('#'+id+' .aux .info',{opacity: 0, y: 25});
							gsap.set('#'+id+' .aux .image',{opacity: 0, y: 25});
							projectsSliderTimeline.to('#'+id+' .aux .info', {
								opacity: 1,
								stagger: 0.2,
								y: 0,
								duration: 0.5
							});
							projectsSliderTimeline.to('#'+id+' .aux .image', {
								opacity: 1,
								stagger: 0.2,
								y: 0,
								duration: 0.5
							},0.2);
							ScrollTrigger.create({
								animation: projectsSliderTimeline,
								trigger: '#'+id,
								//scroller: ".smooth-scroll",
								start: 'top 80%',
								//markers: true
							});
						});
					}

					/* HIGHLIGHT TEXT 1 ANIMATION */
					var animText1 = document.querySelectorAll(".anim-text-1");
					function setupAnimText1() {
						animText1.forEach(title => {
							// Reset if needed
							if(title.anim) {
								title.anim.progress(1).kill();
								title.split.revert();
							}

							title.split = new SplitText(title, {
								type: "lines,words,chars",
								linesClass: "split-line"
							});

							// Set up the anim
							title.anim = gsap.from(title.split.chars, {
								scrollTrigger: {
									trigger: title,
									toggleActions: "restart pause resume reverse",
									//scroller: ".smooth-scroll",
									start: "top 95%",
									//scrub: true,
								},
								duration: 0.4,
								ease: "circ.out",
								y: 80,
								stagger: 0.02,
							});
						});
					}
					ScrollTrigger.addEventListener("refresh", setupAnimText1);
					setupAnimText1();

					/* HIGHLIGHT TEXT 2 ANIMATION */
					var animText2 = document.querySelectorAll(".anim-text-2");
					function setupAnimText2() {
						animText2.forEach(title => {
							// Reset if needed
							if(title.anim) {
								title.anim.progress(1).kill();
								title.split.revert();
							}

							title.split = new SplitText(title, {
								type: "lines,words,chars",
								linesClass: "split-line"
							});

							// Set up the anim
							title.anim = gsap.from(title.split.lines, {
								scrollTrigger: {
									trigger: title,
									//scroller: ".smooth-scroll",
									//toggleActions: "restart pause resume reverse",
									start: "top 85%",
								},
								duration: 0.5,
								//ease: "circ.out",
								//y: 20,
								opacity: 0,
								stagger: 0.1,
							});
						});
					}
					ScrollTrigger.addEventListener("refresh", setupAnimText2);
					setupAnimText2();

					var appearListItems = gsap.utils.toArray('[data-appear-list]');
					appearListItems.forEach(animList => {
						var children = animList.querySelectorAll('.'+animList.getAttribute('data-appear-child'));
						gsap.to(children, { opacity: 0, y: 50 });
						ScrollTrigger.batch(children, {
							onEnter: batch => {
								batch.forEach((item, index) => gsap.to(item, {opacity: 1, y: 0, stagger: 0.25, delay: index * 0.3}))
							},
							once: true,
							start: 'top 80%',
							//end: 'top 30%',
							//scroller: ".smooth-scroll",
						});
					});

					if ($('.images-wrapper-scroll').length) {
						var loopSpeed = 1.5;
						if (browserWidth<1200) { loopSpeed = 1.5; }
						if (browserWidth<880) { loopSpeed = 1; }
						var imagesScrollList = gsap.utils.toArray(".images-wrapper-scroll .image");
						imagesLoop = horizontalLoop(imagesScrollList, { repeat: -1, speed: loopSpeed });
						//imagesScrollList.forEach((box, i) => box.addEventListener("click", () => loop.toIndex(i, {duration: 0.1, ease: "power1.inOut"})));
					}
				},
			});

		});
	})(jQuery); // End of use strict
});

var browserWidth = 0;
var browserHeight = 0;
var inAjax = false;
var featuredProjectsSlider;
var smoother;
var lastScrollDirection = 'down';
var imagesLoop;

/*
This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

Features:
 - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
 - When each item animates to the left or right enough, it will loop back to the other side
 - Optionally pass in a config object with values like "speed" (default: 1, which travels at roughly 100 pixels per second), paused (boolean),  repeat, reversed, and paddingRight.
 - The returned timeline will have the following methods added to it:
   - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
   - current() - returns the current index (if an animation is in-progress, it reflects the final index)
   - times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
 */
function horizontalLoop(items, config) {
	items = gsap.utils.toArray(items);
	config = config || {};
	let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
		length = items.length,
		startX = items[0].offsetLeft,
		times = [],
		widths = [],
		xPercents = [],
		curIndex = 0,
		pixelsPerSecond = (config.speed || 1) * 100,
		snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
		totalWidth, curX, distanceToStart, distanceToLoop, item, i;
	gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
		xPercent: (i, el) => {
			let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
			xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
			return xPercents[i];
		}
	});
	gsap.set(items, {x: 0});
	totalWidth = items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0);
	for (i = 0; i < length; i++) {
		item = items[i];
		curX = xPercents[i] / 100 * widths[i];
		distanceToStart = item.offsetLeft + curX - startX;
		distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
		tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
		  .fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
		  .add("label" + i, distanceToStart / pixelsPerSecond);
		times[i] = distanceToStart / pixelsPerSecond;
	}
	function toIndex(index, vars) {
		vars = vars || {};
		(Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
		let newIndex = gsap.utils.wrap(0, length, index),
			time = times[newIndex];
		if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
			vars.modifiers = {time: gsap.utils.wrap(0, tl.duration())};
			time += tl.duration() * (index > curIndex ? 1 : -1);
		}
		curIndex = newIndex;
		vars.overwrite = true;
		return tl.tweenTo(time, vars);
	}
	tl.next = vars => toIndex(curIndex+1, vars);
	tl.previous = vars => toIndex(curIndex-1, vars);
	tl.current = () => curIndex;
	tl.toIndex = (index, vars) => toIndex(index, vars);
	tl.times = times;
  tl.progress(1, true).progress(0, true); // pre-render for performance
  if (config.reversed) {
    tl.vars.onReverseComplete();
    tl.reverse();
  }
	return tl;
}

/* ANIMATION SWIPER JS SPRINT SLIDER */
function createSpringSlider(el, extendParams = {}) {
	// main swiper el
	const swiperEl = el.querySelector('.swiper-container');

	let previousProgress = 0;
	let isTouched = false;

	const resetDelay = (swiper) => {
	  swiper.slides.forEach((slideEl) => {
		slideEl.style.transitionDelay = '0ms';
	  });
	};

	// init main swiper
	const swiper = new Swiper(swiperEl, {
	  effect: 'creative',
	  speed: 720,
	  followFinger: false,
	  ...extendParams,
	  //modules: [EffectCreative, ...(extendParams.modules || [])],
	  creativeEffect: {
		limitProgress: 100,
		prev: {
		  translate: ['-100%', 0, 0],
		},
		next: {
		  translate: ['100%', 0, 0],
		},
	  },
	  on: {
		...(extendParams.on || {}),
		touchStart(...args) {
		  isTouched = true;
		  if (extendParams.on && extendParams.on.touchStart) {
			extendParams.on.touchStart(...args);
		  }
		},
		touchEnd(...args) {
		  isTouched = false;
		  if (extendParams.on && extendParams.on.touchStart) {
			extendParams.on.touchEnd(...args);
		  }
		},
		// eslint-disable-next-line
		progress(swiper, progress) {
		  if (isTouched) return;
		  if (extendParams.on && extendParams.on.progress) {
			extendParams.on.progress(swiper, progress);
		  }
		  const direction = swiper.progress > previousProgress ? 'next' : 'prev';
		  previousProgress = swiper.progress;
		  const delay = swiper.params.speed / 16;
		  const visibleIndexes = swiper.visibleSlidesIndexes;
		  const firstIndex = visibleIndexes[0];
		  const lastIndex = visibleIndexes[visibleIndexes.length - 1];
		  const setDelay = (slideEl, slideIndex) => {
			if (direction === 'next' && slideIndex >= firstIndex) {
			  slideEl.style.transitionDelay = `${
				(slideIndex - firstIndex + 1) * delay
			  }ms`;
			} else if (direction === 'prev' && slideIndex <= lastIndex + 1) {
			  slideEl.style.transitionDelay = `${
				(lastIndex - slideIndex + 1) * delay
			  }ms`;
			} else {
			  slideEl.style.transitionDelay = `${0}ms`;
			}
		  };
		  swiper.slides.forEach((slideEl, slideIndex) => {
			if (swiper.animating) {
			  slideEl.style.transitionDelay = '0ms';
			  requestAnimationFrame(() => {
				setDelay(slideEl, slideIndex);
			  });
			} else {
			  setDelay(slideEl, slideIndex);
			}
		  });
		},
	  },
	});

	swiper.on('transitionEnd resize touchStart', () => {
	  resetDelay(swiper);
	});

	return swiper;
}
